import {RemotePostAuthRequest} from 'data/usecases/private/authorizations';
import {PostAuthRequest} from 'domain/usecases/private/authorizations';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makePostAuthRequest = (): PostAuthRequest =>
	new RemotePostAuthRequest(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.detail),
		makeAuthorizeHttpClientDecorator(),
	);
